/* GameEditorCabinetComponent.js */

'use strict';
const EventEmitter = require('events').EventEmitter;
const Renderer = require('./GameEditorCabinetRenderer');

class GameEditorCabinetComponent extends EventEmitter {
  constructor(logger) {
    super();
    this._logger = logger;

    this._renderer = new Renderer(this);

    this._registeredViews = [];
    this._registeredActions = [];
    this._selectedView = null;

    this._registerListeners();
  }
  /*******************************************/
  /* START PRIVATE COMPONENT MODEL METHODS */
  /*******************************************/
  _registerListeners() {}
  _unregisterListeners() {}
  /*******************************************/
  /* END PRIVATE COMPONENT MODEL METHODS */
  /* START PUBLIC COMPONENT MODEL METHODS */
  /*******************************************/
  get renderer() {
    return this.getRenderer();
  }
  getRenderer() {
    return this._renderer;
  }
  get logger() {
    return this._logger;
  }
  shutdown() {
    this._unregisterListeners();
    return this._renderer.shutdown().then(
      () => {
        this._registeredActions = undefined;
        this._registeredViews = undefined;
        this._selectedView = undefined;
        this._logger = undefined;
        this._renderer = undefined;
      },
      (err) => {
        this._logger.warn(err, 'GameEditorCabinetComponent.shutdown() error');
      }
    );
  }
  get registeredActions() {
    return this.getRegisteredActions();
  }
  set registeredActions(actionsList) {
    this.setRegisteredActions(actionsList);
  }
  getRegisteredActions() {
    return this._registeredActions;
  }
  setRegisteredActions(actionsList, silent) {
    this._registeredActions = actionsList;
    if (!silent) {
      this.emit('ActionsRegistered');
    }
  }
  addRegisteredAction(actionDef) {
    this._registeredActions.push(actionDef);
    this.emit('ActionAdded', actionDef);
  }

  get registeredViews() {
    return this.getRegisteredViews();
  }
  set registeredViews(viewsList) {
    this.setRegisteredViews(viewsList);
  }
  getRegisteredViews() {
    return this._registeredViews;
  }
  setRegisteredViews(viewsList, silent) {
    this._registeredViews = viewsList;
    if (!silent) {
      this.emit('ViewsRegistered');
    }
  }
  addRegisteredView(viewDef) {
    this._registeredViews.push(viewDef);
    this.emit('ViewAdded', viewDef);
  }

  setSelectedView(viewModuleName) {
    let oldViewModuleName = this._selectedView;
    this._selectedView = viewModuleName;
    this.emit('ViewSelected', viewModuleName, oldViewModuleName);
  }
  selectView(name) {
    this.emit('SelectView', name);
  }

  selectAction(name) {
    this.emit('SelectAction', name);
  }

  enableAction(actionModName) {
    this.emit('EnableAction', actionModName);
  }
  enableAllActions() {
    this.emit('EnableAllActions');
  }
  disableAction(actionModName) {
    this.emit('DisableAction', actionModName);
  }
  disableAllActions() {
    this.emit('DisableAllActions');
  }
  show() {
    this.emit('Show');
  }
  hide() {
    this.emit('Hide');
  }

  hideAction(actionModName) {
    this.emit('HideAction', actionModName);
  }

  showAction(actionModName) {
    this.emit('ShowAction', actionModName);
  }

  hideView(viewModName) {
    this.emit('HideView', viewModName);
  }
  /*******************************************/
  /* END COMPONENT MODEL METHODS */
  /* START HANDLER METHODS */
  /*******************************************/

  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE METHODS */
  /*******************************************/

  _triggerUserActionsPinned(eventData) {
    this.emit('UserActionsPinned', eventData);
  }

  _triggerUserViewsPinned(eventData) {
    this.emit('UserViewsPinned', eventData);
  }

  /*******************************************/
  /* END PRIVATE METHODS */
  /* START PUBLIC API METHODS */
  /*******************************************/

  retardActions(retarded) {
    this.emit('RetardActions', retarded);
  }

  /*******************************************/
  /* END PUBLIC API METHODS */
  /*******************************************/
}
module.exports = GameEditorCabinetComponent;
